import { StickyTableHeader } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const StyledStickyTableHeader = styled(StickyTableHeader)<{
  $isClickable?: boolean;
  $isSorted?: boolean;
}>`
  border-bottom: 1px solid var(--border-default);

  ${({ $isClickable }) =>
    $isClickable &&
    css`
      :hover {
        background-color: var(--surface-hover);
        cursor: pointer;
      }
    `};
`;
